export default class ComponenteNumericoSubtipoModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
    regex1 = '',
    regex2 = null,
  } = {}) {
    this.id = id
    this.nome = nome
    this.descricao = descricao
    this.regex1 = regex1
    this.regex2 = regex2
  }
}
